import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelaxOverlayComponent } from './relax-overlay.component';

@NgModule({
  imports: [CommonModule, RelaxOverlayComponent],
  exports: [RelaxOverlayComponent],
})
export class RelaxOverlayModule {}
